<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Canteen Fees Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense justify="center">
        <v-col sm="3" md="3" cols="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
            item-text="ay" return-object label="Academic Year" outlined persistent-hint
            hint="Please Select Academic Year" @change="getInstallmentData()"></v-autocomplete>
        </v-col>
        <v-col sm="4" md="3" cols="12" v-if="canteen_installment_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="installment" multiple :items="canteen_installment_list"
            item-text="name" item-value="id" label="Canteen Installment" outlined persistent-hint
            hint="Please Select Installment"></v-autocomplete>
        </v-col>
        <v-col sm="6" md="4" cols="12" v-if="canteen_installment_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="std" multiple :items="standard_list" item-text="standard"
            item-value="id" label="Standard" outlined persistent-hint hint="Please Select Standard"
            @change="stud = null"></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="current_academic_year && installment.length > 0 && std.length > 0">
        <v-col sm="3" cols="12" md="2">
          <v-btn rounded class="button mt-6" :loading="loader" @click="getReport()">Get Report</v-btn>
        </v-col>
      </v-row>     
      <br>  
        <div id="my-table-id" v-if="learner_installments_details != ''">
          <v-data-table :headers="headers" :items="bookList1" :search="search" @current-items="getFiltered"
            class="elevation-1 mytable" dense>
            <template v-slot:top>
              <v-toolbar flat>
                <v-row>
                  <v-col sm="2">
                     <v-btn rounded class="mr-2 pb-2 pt-2" color="success" outlined small
                    @click="fnExcelReport('my-table-id', 'CanteenfeesReportwws')" :loading="loader"><v-icon
                      color="success">mdi-export</v-icon>Export</v-btn>
                  </v-col>
                  <v-col sm="2" cols="12">
                    <v-checkbox v-model="filterZeroBalance" style="font-weight: bold;" label="0 Balance" hide-details
                      dense></v-checkbox>
                  </v-col>
                  <v-col sm="3" cols="12">
                    <v-checkbox v-model="filterBalance" style="font-weight: bold;" label="Balance" hide-details
                      dense></v-checkbox>
                  </v-col>
                  <v-col sm="5" cols="12"><v-text-field v-model="search" append-icon="mdi-magnify" label="Search"
                      single-line hide-details></v-text-field></v-col>
                </v-row>
              </v-toolbar>

              <template>
                <v-row dense justify="center" align="center">
                  <tr class="t-row">
                    <div>
                      <th>
                        <v-row dense>
                          <span v-for="header in headers" :key="header.text">
                            <span v-if="filters.hasOwnProperty(header.value)">
                              <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                                color="#0F2027" :label="header.text" multiple clearable
                                :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                            </span>
                          </span>
                        </v-row>
                      </th>
                    </div>
                  </tr>
                </v-row>


              </template>
            </template>
            <template v-slot:item="{ item }">
              <tr :class="{ 'color-row': item.paid_till_now === 0 }">
                <td v-for="header, index in headers.filter(h => h.value != 'print') " :key="index">{{ item[header.value]
                  }}
                </td>
                <td>
                  <span v-for="receipt in item.receipt_no" :key="receipt">
                    <v-tooltip top color="warning">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on"
                          @click="print(receipt, item.ay)">
                          <v-icon color="warning">mdi-printer</v-icon>{{ receipt }}
                        </v-btn>
                      </template>
                      <span>Print Fee Receipt!!!</span>
                    </v-tooltip>
                  </span>
                </td>
              </tr>
            </template>
            

          </v-data-table>
        </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      loader: false,
      extraBreadcrumbItems: [


      ],
      breadcrumbClass: "breadcrumb-style1",
      overlay: false,
      color: "",
      snackbar: false,
      search: null,
      snackbar_msg: null,
      current_academic_year: null,
      stream: "",
      std: [],
      academic_year_list: null,
      standard_list: null,
      canteen_installment_list: [],
      installment: [],
      headers: [
        {
          text: "Sr.No.",
          align: "left",
          sortable: false,
          value: "srno",
        },
        {
          text: "PRN",
          align: "left",
          sortable: false,
          value: "prn",
        },

        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Canteen Menu Type",
          align: "left",
          sortable: false,
          value: "canteenmenutype",
        },
        {
          text: "Standard",
          align: "left",
          sortable: false,
          value: "standard",
        },
        {
          text: "Division",
          align: "left",
          sortable: false,
          value: "division",
        },
        {
          text: "Installment",
          align: "left",
          sortable: false,
          value: "canteeninstallment",
        },
        {
          text: "Amount",
          align: "left",
          sortable: false,
          value: "amount",
        },
        {
          text: "Paid",
          align: "left",
          sortable: false,
          value: "paid_till_now",
        },
        {
          text: "Balance",
          align: "left",
          sortable: false,
          value: "balance",
        },
        { text: "Print Receipt", value: "print" },
      ],
      filterZeroBalance: true,
      filterBalance: false,
      filters: {

        canteenmenutype: [],
        prn: [],
        standard: [],
        division: [],
        canteeninstallment: [],
      },
      learner_installments_details: []
    };
  },
  // computed: {
  //   bookList1() {
  //     return this.learner_installments_details.filter((d) => {
  //       return Object.keys(this.filters).every((f) => {
  //         return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
  //       });
  //     });
  //   },
  // },
  computed: {
    bookList1() {
      return this.learner_installments_details.filter((d) => {
        // Check the existing filters
        const matchesExistingFilters = Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });

        // Check the new checkbox filters
        const matchesZeroBalance = this.filterZeroBalance ? d.balance === 0 : false;
        const matchesBalance = this.filterBalance ? d.balance > 0 : false;

        // If both filters are selected, include all items
        const matchesAnyBalance = this.filterZeroBalance && this.filterBalance ? true : (matchesZeroBalance || matchesBalance);

        return matchesExistingFilters && matchesAnyBalance;
      });
    },
  },
  methods: {
    fnExcelReport(id, name) {
      let tab_text = `<table border='1px'>
        <tr>
          <th>Sr.No</th>
          <th>PRN</th>
          <th>Name</th>
          <th>Canteen Menu type</th>
          <th>Standard</th>
          <th>Division</th>
          <th>Installment</th>
          <th>Amount</th>
          <th>Paid</th>
          <th>Balance</th>

        </tr>`;

      this.bookList1.forEach((item, index) => {
        tab_text += `
        <tr>
            <td>${index + 1}</td> 
            <td>${item.prn}</td>
            <td>${item.name}</td>
            <td>${item.canteenmenutype}</td>
            <td>${item.standard}</td>
            <td>${item.division}</td>
            <td>${item.canteeninstallment}</td>
            <td>${item.amount}</td>
            <td>${item.paid_till_now}</td>
            <td>${item.balance}</td>
        </tr>`;
      });

      tab_text += '</table>';

      const blob = new Blob([tab_text], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.learner_installments_details.map((d) => d[val]);
    },
    // columnValueList(val) {
    //   return this.data_list.map((d) => d[val]);
    // },

    // ExportToExcel() {
    //   var htmltable = document.getElementById("my-table-id");
    //   var html = htmltable.outerHTML;
    //   window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
    // },
    print(receipt_no, ay) {
      this.receipt_no = receipt_no;
      this.$session.set("receipt_no", JSON.stringify(receipt_no));
      this.$session.set("ay", JSON.stringify(ay));
      let routeData = this.$router.resolve({ name: "canteen-receipt" });
      window.open(routeData.href, "_blank");
    },
    getReport() {
      const data = {
        ay: this.current_academic_year.id,
        std: this.std,
        installment: this.installment,
      };
      this.learner_installments_details = [];
      this.loader = true;
      axios
        .post("/Canteen/getCanteenFeesReportWWS", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.loader = false;
            this.learner_installments_details = res.data.learner_installments
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.loader = false;
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getInstallmentData() {
      this.overlay = true;
      this.canteen_installment_list = []
      const data = {
        academicYear: this.current_academic_year.id,
      };
      axios
        .post("/Canteen/getInstallmentDataByAy", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.canteen_installment_list = res.data.canteen_installment_list;
            // this.stud_list = res.data.stud_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    onload() {
      axios
        .post("/InstallmentStructureDetails/getAllData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.academic_year_list = res.data.ay_data;
            // this.current_academic_year = res.data.cay;
            this.standard_list = res.data.standard_list;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.get_ay_std_ft_loader = false;
        });
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.color-row {
  background-color: lightskyblue;
  /* color: white; */
}

.color-row:hover {
  background-color: rgb(56, 175, 248) !important;
}
</style>